import useReduxStateMarket, {
  MarketPageType,
} from '@/pages/Market/hooks/useReduxStateMarkets';
import { getReadableCountry } from '@/utilities/markets';
import { find, get } from 'lodash';
import useIndustriesFetch from '@/pages/Market/hooks/useIndustriesFetch';

export const usIndices = 'Dow Jones, Nasdaq, S&P 500 Summary';

export default function useTitleGenerator(
  {
    marketTemplate,
    industryTemplate,
    sectorTemplate,
    tertiaryTemplate,
  }: {
    marketTemplate: string;
    sectorTemplate: string;
    industryTemplate: string;
    tertiaryTemplate?: string;
  },
  withIndex?: boolean
): string {
  const { market, sector, secondary, tertiary, marketPageType } =
    useReduxStateMarket();
  const { industries } = useIndustriesFetch(market, false);
  const foundSector = find(industries.sector, ['slug', sector]);
  const foundSecondary = find(industries.secondary, ['slug', secondary]);
  const foundTertiary = find(industries.tertiary, ['slug', tertiary]);
  const readableSector = get(foundSector, 'label', '');
  const readableSecondary = get(foundSecondary, 'label', '');
  const readableTertiary = get(foundTertiary, 'label', '');
  const readableMarket = getReadableCountry(market);
  const marketMainIndex = getReadableCountry(market, 'mainIndex');
  const marketWithIndex = `${readableMarket} ${
    market === 'us' ? '' : `(${marketMainIndex})`
  }`;
  const parentIndustry =
    marketPageType === MarketPageType.TERTIARY
      ? readableSecondary
      : readableSector;
  const replacePlaceholder = (template) =>
    template
      .replace('[Market]', withIndex ? marketWithIndex : readableMarket)
      .replace('[Sector]', readableSector)
      .replace('[Industry]', readableTertiary || readableSecondary)
      .replace('[ParentIndustry]', parentIndustry);

  if (marketPageType === MarketPageType.MARKET)
    return replacePlaceholder(marketTemplate);
  if (marketPageType === MarketPageType.SECTOR)
    return replacePlaceholder(sectorTemplate);
  if (
    marketPageType === MarketPageType.SECONDARY ||
    marketPageType === MarketPageType.TERTIARY
  ) {
    if (marketPageType === MarketPageType.TERTIARY && tertiaryTemplate) {
      return replacePlaceholder(tertiaryTemplate);
    }
    return replacePlaceholder(industryTemplate);
  }

  return '';
}
